/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultDevise } from '../../models/api-response-paged-result-devise';
import { PagedRequestDevise } from '../../models/paged-request-devise';

export interface SearchDevise$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestDevise
}

export function searchDevise(http: HttpClient, rootUrl: string, params: SearchDevise$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultDevise>> {
  const rb = new RequestBuilder(rootUrl, searchDevise.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultDevise>;
    })
  );
}

searchDevise.PATH = '/v1/api/ui/devise/search';
